<div class="container small-text mb-4">
	<div class="row align-items-center">
		<div class="col-md-2 p-1 fw-bold">Maks pokoi</div>
		<div class="col-md-3 p-1">
			@if (maxRooms()?.mode === MaxRoomStatus.SAVE) {
				<form [formGroup]="maxRoomsForm">
					<mat-form-field appearance="outline" class="small-version">
						<input matInput type="number" name="numberInput" formControlName="maxRooms" min="0" />
						@if (maxRoomsForm.controls['maxRooms'].errors?.required) {
							<mat-error>Ilość maksymalna pokoi jest wymagana</mat-error>
						}
					</mat-form-field>
				</form>
			} @else {
				{{ maxRooms()?.maxRooms }}
			}
		</div>
		<div class="col-md-3 p-1 d-flex">
			@if (maxRooms()?.mode === MaxRoomStatus.SAVE) {
				<button class="me-2 edit-button" mat-raised-button (click)="changeMaxRooms()" color="warn">
					Zapisz
				</button>
				<button class="me-2 cancel-button" mat-raised-button (click)="cancelMaxRooms()" color="primary">
					Anuluj
				</button>
			} @else {
				<button class="me-2 edit-button" mat-raised-button (click)="editMaxRooms()" color="primary">
					Edytuj
				</button>
			}
		</div>
	</div>
</div>
